import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Pages, SampleCardTitle, SamplePageTitle } from "../../../constants";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { SamplePageSubTitle } from "../../../data/pages/Pages";

const SamplePageContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={SamplePageTitle} parent={Pages} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={SampleCardTitle} span={SamplePageSubTitle} tag />
              <CardBody>
                <p>{"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."}</p>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SamplePageContainer;
